module.exports = __webpack_public_path__ + "static/media/homeaway.7d2f432c.ico";